import { render } from "./OverviewContactBlock.vue?vue&type=template&id=9ba53d6a&scoped=true"
import script from "./OverviewContactBlock.vue?vue&type=script&lang=js"
export * from "./OverviewContactBlock.vue?vue&type=script&lang=js"

import "./OverviewContactBlock.vue?vue&type=style&index=0&id=9ba53d6a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ba53d6a"]])

export default __exports__